import { render, staticRenderFns } from "./SetAllociontModal.vue?vue&type=template&id=0382f97c&scoped=true"
import script from "./SetAllociontModal.vue?vue&type=script&lang=js"
export * from "./SetAllociontModal.vue?vue&type=script&lang=js"
import style0 from "./SetAllociontModal.vue?vue&type=style&index=0&id=0382f97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0382f97c",
  null
  
)

export default component.exports